export default {
  from: 'Von',
  to: 'An',
  enterNameOrNumber: 'Nummer oder Name eingeben ...',
  typeMessage: 'Nachricht eingeben ...',
  send: 'Senden',
};
